import { render, staticRenderFns } from "./appRegisterTab.vue?vue&type=template&id=3eda32e6&scoped=true"
import script from "./appRegisterTab.vue?vue&type=script&lang=js"
export * from "./appRegisterTab.vue?vue&type=script&lang=js"
import style0 from "./appRegisterTab.vue?vue&type=style&index=0&id=3eda32e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda32e6",
  null
  
)

export default component.exports